import {AppConfigService} from './app-config.service';
import {LoggedUserService} from './logged-user.service';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ClaimCalculationDocumentsDto} from '../model';
import {AbstractAuditedRelatedService} from './abstract-audited-related.service';

@Injectable()
export class ClaimCalculationDocumentsService extends AbstractAuditedRelatedService<ClaimCalculationDocumentsDto> {
  protected url = this.urlPrefix + 'claim-calculation';
  protected midUrl = 'documents';

  constructor(public http: HttpClient, appConfigService: AppConfigService, loggedUserService: LoggedUserService) {
    super(http, appConfigService, loggedUserService);
  }
}
